import { createCreateUserValidator } from "#validators/users.validator.factory";
// Use factory function with pass-through translation for type inference
// This ensures the type matches the translated validator structure
const createUserValidatorForType = createCreateUserValidator((key) => key);
